// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sF3yEsskuVe6ewzuZKgw {
    background-color: #F7F7F7;

    padding: 32px;
    min-height: calc(100vh - 70px);
    width: 70%;
    max-width: calc(100% - 425px);
    box-sizing: border-box;
}

.P0KKQPvL1kbSmoes5Cvv {
    display: flex;
    flex-direction: row;
    column-gap: 16px;
    flex-wrap: wrap;
    row-gap: 16px;
}

.CVRz7OaN_Hwgmu4VRPzt {
    width: 100%;

    grid-column-start: 1;
    grid-column-end: 6;

    font-weight: 500;
    font-size: 18px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    text-align: center;
}

@media screen and (max-width: 768px) {
    .sF3yEsskuVe6ewzuZKgw {
        padding: 32px 32px 16px;
    }
}

@media screen and (max-width: 425px) {
    .sF3yEsskuVe6ewzuZKgw {
        padding: 16px 16px 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardOpportunity/DashboardOpportunity.module.css"],"names":[],"mappings":"AAGA;IACI,yBAAyB;;IAEzB,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;;IAEX,oBAAoB;IACpB,kBAAkB;;IAElB,gBAAgB;IAChB,eAAe;IACf,mDAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["@value colors: \"../../../components/library/style/colors.css\";\n@value color-text-subtle from colors;\n\n.opportunity {\n    background-color: #F7F7F7;\n\n    padding: 32px;\n    min-height: calc(100vh - 70px);\n    width: 70%;\n    max-width: calc(100% - 425px);\n    box-sizing: border-box;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    column-gap: 16px;\n    flex-wrap: wrap;\n    row-gap: 16px;\n}\n\n.empty {\n    width: 100%;\n\n    grid-column-start: 1;\n    grid-column-end: 6;\n\n    font-weight: 500;\n    font-size: 18px;\n    color: color-text-subtle;\n    text-align: center;\n}\n\n@media screen and (max-width: 768px) {\n    .opportunity {\n        padding: 32px 32px 16px;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    .opportunity {\n        padding: 16px 16px 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../components/library/style/colors.css"`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"opportunity": `sF3yEsskuVe6ewzuZKgw`,
	"row": `P0KKQPvL1kbSmoes5Cvv`,
	"empty": `CVRz7OaN_Hwgmu4VRPzt`
};
export default ___CSS_LOADER_EXPORT___;
